<template>
  <gg-card height="100%" class="d-flex flex-column">
    <gg-card-header>
      Upgrade Your Account
    </gg-card-header>
    <gg-card-text>
      Upgrading your service can increase your available resources. Click the button below to contact our Sales Team
      regarding a possible upgrade.
    </gg-card-text>
    <v-card-actions class="justify-end mt-auto pa-4">
      <gg-btn :to="{ name: 'support_ticketnew', query: { d: 'Sales', s: alert.serviceID, sbj: subject } }">
        Upgrade Your Account
      </gg-btn>
    </v-card-actions>
  </gg-card>
</template>

<script>
export default {
  name: 'Upgrade',
  props: {
    alert: {
      required: true,
      type: Object
    }
  },
  computed: {
    subject () {
      return `Service Upgrade: ${this.alert.title}`
    }
  }
}
</script>
